import React, { useState } from 'react';
import NewSuggestionTags from '../../CreateContent/NewSuggestionTags/NewSuggestionTags';
import ImageGeneration from '../ImageGeneration/ImageGeneration';
import ReviewContent from '../ReviewContent/ReviewContent';
import StepDetails from '../StepDetails/StepDetails';
import StepsSidebar from '../StepsSidebar/StepsSidebar';
import './CreatedContent.scss';

const CreatedContent = () => {
  const [currentStep, setCurrentStep] = useState("Detalhamento");
  const [formData, setFormData] = useState({
    title: "",
    contentOriginUrl: "",
    mediaType: "TEXT",
    isAccessible: false,
    isDraft: false,
    shortDescription: "",
    content: "",
    diversity: false,
    listDiversity: [],
    fixedDiversityItems: [],
    imageUrl: "",
    listTags: [],
    listTagsID: [],
  });

  const [visitedSuggestion, setVisitedSuggestion] = useState([]);

  const handleCreateContent = (newTag) => {
    setFormData(prev => ({
      ...prev,
      listTags: [...prev.listTags, newTag],
    }));
  };
  console.log(formData)

  return (
    <div className="CreatedContent">
      <StepsSidebar currentStep={currentStep} onStepChange={setCurrentStep} />

      <div className="step-content">
        {currentStep === "Detalhamento" && (
          <StepDetails setCurrentStep={setCurrentStep} formData={formData} setFormData={setFormData} />
        )}
        {currentStep === "Tags" && (
          <NewSuggestionTags
            onBack={() => setCurrentStep("Detalhamento")}
            setCurrentStep={setCurrentStep}
            storageSuggestion={handleCreateContent}
            listTagsID={formData.listTagsID || []}
            setListTagsID={(newList) =>
              setFormData((prev) => ({ ...prev, listTagsID: newList }))
            }
            listTags={formData.listTags || []}
            setListTags={(newList) =>
              setFormData((prev) => ({ ...prev, listTags: newList }))
            }
            visitedSuggestion={visitedSuggestion}
            setVisitedSuggestion={setVisitedSuggestion}
            formData={formData}
            setFormData={setFormData}
          />


        )}
        {currentStep === "Geração de imagem" && (
          <ImageGeneration
            onBack={() => setCurrentStep("Tags")} setCurrentStep={setCurrentStep} formData={formData} setFormData={setFormData} />
        )}

        {currentStep === "Revisão" && (
          <ReviewContent
            formData={formData}
            onBack={() => setCurrentStep("Geração de imagem")}
            onSubmit={() => {
              console.log("Conteúdo finalizado:", formData);
              alert("Conteúdo criado com sucesso!");
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CreatedContent;
